import Carousel, { Dots, autoplayPlugin } from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

import buenamozabistro1 from '../img/buenamozabistro1.jpg';
import buenamozabistro2 from '../img/buenamozabistro2.jpg';
import buenamozabistro3 from '../img/buenamozabistro3.jpg';
import buenamozabistro4 from '../img/buenamozabistro4.jpg';
import buenamozabistro5 from '../img/buenamozabistro5.jpg';
import buenamozabistro6 from '../img/buenamozabistro6.jpg';
import buenamozabistro8 from '../img/buenamozabistro8.jpg';
import buenamozabistro10 from '../img/buenamozabistro10.jpg';
import Icon from 'react-fa';
const SliderVertical=({setShowMenu,showMenu})=>{

    return (
        <>
            <Carousel 
             plugins={[
                'infinite',
                'fastSwipe',
               {
                 resolve: autoplayPlugin,
                 options: {
                    interval: 2000,
                    slidesPerScroll:2
                 }
               },
             ]}   
            // animationSpeed={1000}

            

            // slidesPerPage={3}
            // slidesPerScroll={2}
            // //animationSpeed={1500}
            // autoPlay={1000}
            // stopAutoPlayOnHover
            // offset={50}
            // itemWidth={400}
            // clickToChange
            // centered
            // infinite        

            // arrowLeft={<Icon className="icon-example" name="arrow-left" />}
            // arrowRight={<Icon className="icon-example" name="arrow-right" />}
            // addArrowClickHandler   

            // onClick={()=>setShowMenu(!showMenu)}
            >
            <img src={buenamozabistro1} />
            <img src={buenamozabistro2} />
            <img src={buenamozabistro3} />
            <img src={buenamozabistro4} />
            <img src={buenamozabistro5} />
            <img src={buenamozabistro6} />
            <img src={buenamozabistro8} />
            <img src={buenamozabistro10} />
            </Carousel>            
        </>
    )
}

export  default SliderVertical;